module.exports = __webpack_public_path__ + "img/1 6-2.1df43847.png";